import AppBar from "@mui/material/AppBar";
import Divider from "@mui/material/Divider";

import Container from "~franchise-website/common/Container";

import { Footer, Topbar } from "./components";

export const Fluid = ({ children }) => {
	return (
		<div>
			<AppBar position="fixed">
				<Container
					paddingY={{ xs: 1 / 2, sm: 1 }}
					maxWidth="100%">
					<Topbar />
				</Container>
			</AppBar>
			<main>{children}</main>
			<Divider />
			<Container paddingY={4}>
				<Footer />
			</Container>
		</div>
	);
};
